import { SVG, Text } from '@svgdotjs/svg.js';

export class CustomTextSvg {
  $svgjs: Text;
  fontSize: number;
  fontFamily: string;
  baseFontSize: number;
  baseWidth: number;
  baseHeight: number;
  constructor(options: {
    text: string;
    baseFontSize: number;
    baseWidth?: number;
    baseHeight?: number;
    fontFamily: string;
  }) {
    this.baseFontSize = options.baseFontSize;
    this.fontSize = options.baseFontSize;
    this.fontFamily = options.fontFamily;
    this.baseWidth = options?.baseWidth || 80;
    this.baseHeight = options?.baseHeight || 100;
    this.$svgjs = SVG()
      .attr({
        'dominant-baseline': 'middle',
        'text-anchor': 'middle',
      })
      .text(options.text)
      .font({ fill: '#222', family: this.fontFamily, size: this.fontSize });
    const newer = this.$svgjs.bbox();
    const newWidth = newer ? newer.width : this.baseWidth;
    const newHeight = newer ? newer.height : this.baseHeight;
    if (newWidth > this.baseWidth) this.fontSize = this.svgWidthFont(newWidth);
    let heightFont = this.fontSize;
    if (newHeight > this.baseHeight) heightFont = this.svgHeightFont(newHeight);
    if (heightFont < this.fontSize) this.fontSize = heightFont;
  }

  updateFontsize(newFontSize: number): void {
    this.fontSize = newFontSize;
  }

  svgWidthFont(svgWidth: number): number {
    const fontCalc = (this.baseWidth / (svgWidth + 2)) * this.baseFontSize;
    return svgWidth > this.baseWidth ? fontCalc : this.baseFontSize;
  }

  svgHeightFont(svgHeight: number): number {
    const fontCalc = (this.baseHeight / (svgHeight + 2)) * this.baseFontSize;
    return svgHeight > this.baseHeight ? fontCalc : this.baseFontSize;
  }

  getYAxis(lines: number): string {
    return lines === 1 ? `25%` : `${20 / lines}%`;
  }
}
